import { Button } from '@toggle/design-system';
import React from 'react';

import SomethingWentWrong from '../../something-went-wrong.svg';
import styles from './ChartEmpty.module.scss';

export interface ChartEmptyLocales {
  imgAlt: string;
  title: string;
  description: string;
  btnLabel: string;
}

export interface ChartEmptyProps {
  onSearchAgain?: () => void;
  assetName?: string;
  locales: ChartEmptyLocales;
}

export const ChartEmpty = ({
  onSearchAgain,
  assetName = '',
  locales,
}: ChartEmptyProps) => {
  return (
    <div className={styles.chartEmptyRoot} data-testid="chart-empty">
      <SomethingWentWrong className={styles.emptyImage} alt={locales.imgAlt} />
      <div className={styles.title} data-testid="title">
        {locales.title.replace('{{asset}}', assetName)}
      </div>
      <div className={styles.description}>{locales.description}</div>
      <Button
        data-testid="chart-empty-button"
        label={locales.btnLabel}
        onClick={onSearchAgain}
      />
    </div>
  );
};
